import { createStore } from 'redux';
import { rootReducer } from '../../rootReducer';

export const createServerStore = initialState =>
  createStore(rootReducer, initialState);
